import Box from 'components/Box';
import Text from 'components/Text';
import styled from 'styled-components';
import Button from 'components/Button';
import { IServiceItemData } from 'services/shop/types/categories';

type IAddOnsInputProps = {
  value?: IServiceItemData[];
  onChange?: (value: IServiceItemData[]) => void;
  isShowAddNewServices?: boolean;
  onAddNewServices?: () => void;
  onAddServices?: () => void;
};

const AddOnsInput = ({
  value,
  onChange,
  isShowAddNewServices = false,
  onAddNewServices,
  onAddServices,
}: IAddOnsInputProps) => {
  const handleRemoveService = (id: string) => {
    onChange?.(value?.filter((item) => item.id !== id) || []);
  };

  return (
    <Container>
      <Box display='flex' alignItems='center' justifyContent='space-between' gap='2' alignSelf='stretch'>
        <Text variant='H8' style={{ fontWeight: 500 }}>
          Add-Ons
        </Text>
        <Box display='flex' alignItems='center' gap='3'>
          {isShowAddNewServices && (
            <Button ntype='ORANGE' icon='addWhite' onClick={onAddNewServices} height={3}>
              Add New Services
            </Button>
          )}
          <Button ntype='GREEN' icon='addWhite' onClick={onAddServices} height={3}>
            Add Services Add-On
          </Button>
        </Box>
      </Box>
      <Box display='flex' flexDirection='column' gap='2'>
        <Text variant='CONTENT_2' style={{ color: '#64748B' }}>
          SELECTED SERVICES
        </Text>
        <ListContainer>
          {value?.map((item) => (
            <ItemContainer key={item.id}>
              <div>{item.serviceName}</div>
              <IconBox onClick={() => handleRemoveService(item.id)}>
                <IconClose />
              </IconBox>
            </ItemContainer>
          ))}
        </ListContainer>
      </Box>
    </Container>
  );
};

export default AddOnsInput;

const Container = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 4px;
  background: #fff;
  border: 1px solid #ccd4dc;
  font-family: Poppins;
`;

const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const ItemContainer = styled.div`
  display: flex;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 100px;
  border: 1px solid #d7edff;
  background: #eef4ff;
  overflow: hidden;
  color: #4384ff;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  text-transform: capitalize;
  &:hover {
    background: #d7edff;
  }
`;

const IconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
`;

const IconClose = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.4547 2.54489C13.7559 2.84616 13.7559 3.33461 13.4547 3.63588L3.63574 13.4548C3.33447 13.7561 2.84601 13.7561 2.54474 13.4548C2.24347 13.1536 2.24347 12.6651 2.54474 12.3638L12.3637 2.54489C12.665 2.24362 13.1534 2.24362 13.4547 2.54489Z'
      fill='#4384FF'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.54532 2.54489C2.84659 2.24362 3.33505 2.24362 3.63632 2.54489L13.4553 12.3638C13.7565 12.6651 13.7565 13.1536 13.4553 13.4548C13.154 13.7561 12.6655 13.7561 12.3643 13.4548L2.54532 3.63588C2.24405 3.33461 2.24405 2.84616 2.54532 2.54489Z'
      fill='#4384FF'
    />
  </svg>
);
